<!-- Content wrapper -->
<div class="soc-comms-wrapper">
  <!-- Ticketing Emails section with full width -->
  <div class="full-width-section">
    <div class="ticketing-container">
      <app-ticketing></app-ticketing>
    </div>
  </div>

  <!-- Call Tree section with full width -->
  <div class="full-width-section">
    <div class="calltree-container">
      <app-calltree></app-calltree>
    </div>
  </div>
</div>
<div kendoDialogContainer></div>
